








































import Vue from 'vue'
import { Component, Prop, Emit, Watch } from 'vue-property-decorator'

@Component
export default class AppDatePicker extends Vue {
  @Prop(String) readonly value!: string;
  @Prop(String) readonly label!: string;
  @Prop({ type: String }) readonly placeholder!: string;
  @Prop({ type: Boolean, default: false }) readonly required!: boolean;
  @Prop({ type: [Number, String], default: 289 }) readonly width!:
    | number
    | string;

  @Prop({ type: [Number, String], default: 36 }) readonly height!:
    | number
    | string;

  @Prop({ type: String, default: 'date' }) readonly type!: string;
  @Prop({ type: String, default: '2099-12-31' }) readonly max!: string;
  @Prop({ type: String, default: '1900-12-31' }) readonly min!: string;
  @Prop({ type: Boolean }) readonly disabled!: boolean;
  @Prop({ type: Boolean, default: true }) readonly showClear!: boolean;

  model = '';

  show = false;

  rules = {
    required: (value: string) => !!value || 'Required.'
  };

  mounted () {
    this.model = this.value
  }

  clearModel () {
    this.valueChangedHandler('')
  }

  @Watch('value')
  onValueChanged (val: string) {
    this.model = val
  }

  @Emit('input')
  valueChangedHandler (val: string) {
    this.model = val
    this.show = false
    return val
  }

  @Emit()
  submit () {
    // do noting
  }

  allowedDates (val: string) {
    return this.$moment().diff(val, 'days') > 0
  }
}
